/**
 * LIMITED-BOOKING Availability Type Configuration
 *
 * Default zone configurations for LIMITED-BOOKING availability type.
 * TODO: Implementation pending - this availability type is for future use.
 */

import { AvailabilityTypePageConfig } from '../models/checkout-journey.types';

export const LIMITED_BOOKING_AVAILABILITY_TYPE_CONFIG: AvailabilityTypePageConfig[] = [
  // TODO: Define configs when LIMITED-BOOKING availability type is implemented
];
